import PropTypes from 'prop-types'


import { FormModal } from '../../default'
import { AddBypassCustomerForm } from '../../forms'

const AddBypassCustomerModal = ({ open, onClose, setSnackbarData }) => {

    return (
        <FormModal
            title='Adicionar CNPJ'
            open={open} onClose={onClose}
        >
            <AddBypassCustomerForm onClose={onClose} setSnackbarData={setSnackbarData} />
        </FormModal>
    )

}

AddBypassCustomerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    setSnackbarData: PropTypes.func.isRequired
}

export default AddBypassCustomerModal